import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import Profile from './pages/Profile';
import OrderHistory from './pages/OrderHistory';
import Login from './pages/Login';
import AdminPanel from './pages/AdminPanel';
import CustomOrder from './pages/CustomOrder';
import MyCustomOrders from './pages/MyCustomOrders';
import CategoryUpdater from './pages/CategoryUpdater';
import CategoryFixer from './pages/CategoryFixer';
import TeamManagement from './pages/TeamManagement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './styles/App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={<Profile />} />
              <Route path="/orders" element={<OrderHistory />} />
              <Route path="/my-custom-orders" element={
                <ProtectedRoute>
                  <MyCustomOrders />
                </ProtectedRoute>
              } />
              <Route path="/custom-order" element={<CustomOrder />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/team-management" element={<TeamManagement />} />
              <Route path="/category-updater" element={<CategoryUpdater />} />
              <Route path="/category-fixer" element={<CategoryFixer />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
